import { useState, useEffect } from 'react';
import { getApiKey, setApiKey } from '../api';

export function useApiKey() {
  const [apiKey, setLocal] = useState(() => getApiKey());
  const [showModal, setShowModal] = useState(false);

  useEffect(() => {
    const isLocal =
      !window.location.hostname.includes('claude.ai') &&
      !window.location.hostname.includes('anthropic.com');
    if (isLocal && !apiKey) setShowModal(true);
  }, [apiKey]);

  const save = (key) => {
    setApiKey(key);
    setLocal(key);
    setShowModal(false);
  };

  return { apiKey, showModal, setShowModal, save };
}
